export default "__VITE_ASSET__BI_zt_zs__"